import React from 'react';
import PropTypes from 'prop-types';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel as Slider } from 'react-responsive-carousel';

const Carousel = (props) => {
  let elements = React.Children.toArray(props.children);

  if (elements.length === 1) {
    elements = React.cloneElement(elements[0]);
  } else if (elements.length > 0) {
    let lastElement = elements[elements.length - 1];
    elements = [React.cloneElement(elements[0])]
      .concat(elements.slice(1, -1))
      .concat(React.cloneElement(lastElement));
  }
  return (
    <Slider
      {...props}
      showThumbs={false}
      showStatus={false}
      autoPlay={false}
      showIndicators={props.showIndicators}
    >
      {elements}
    </Slider>
  );
};

Carousel.propTypes = {
  children: PropTypes.any,
  showIndicators: PropTypes.bool
};

export default Carousel;
